<template>
	<div>
		<div class="main">
			<figure>
				<img src="../../../assets/img/privacy/infoSetup.png">
				<figcaption>
					<p>手机号：</p><input type="number" name="" v-model="userInfo.userPhone"  disabled="disabled"
						placeholder="15112349876"/>
					<span @click="aleditPhone" class="showHand">修改</span>
				</figcaption>
			</figure>
			<!-- 弹框修改手机号 -->
			<div class="editPhone" v-show="editStatus">
				<div class="editPhone_nav">
					<div class="editPhone_nav_top">
						<p>修改手机号</p>
						<img src="../../../assets/img/comm/icon_cha.png" @click="cancle" class="showHand">
					</div>
					<ul class="text">
						<li>
							<img src="../../../assets/img/privacy/blueOne.png">
							<p>手机验证</p>
						</li>
						<p class="line"></p>
						<li>
							<img src="../../../assets/img/privacy/noTwo.png">
							<p>绑定手机</p>
						</li>
					</ul>
					<div class="form">
						<input type="number" name="" value="" placeholder="请输入原手机号" v-model="loginPhone"
							oninput="if(value.length>11)value=value.slice(0,11)" maxlength="11" />
						<input type="number" placeholder="请输入验证码" class="postCode" maxlength="6" v-model="loginCode"
							oninput="if(value.length>6)value=value.slice(0,6)" />
						<!-- 验证码倒计时 -->
						<p class="showHand code" @click="throttle(handleRequresCode,3000)">{{codeTime?codeTime:'获取验证码'}}
						</p>
						<button type="button" class="showHand" @click="throttle(next,3000)">下一步</button>
					</div>
				</div>
			</div>
			<!-- 最后验证 -->
			<div class="editPhone" v-show="nextStatus">
				<div class="editPhone_nav">
					<div class="editPhone_nav_top">
						<p>修改手机号</p>
						<img src="../../../assets/img/comm/icon_cha.png" @click="cancle" class="showHand">
					</div>
					<ul class="text">
						<li>
							<img src="../../../assets/img/privacy/blueOne.png">
							<p>手机验证</p>
						</li>
						<p class="line"></p>
						<li>
							<img src="../../../assets/img/privacy/blueOne.png">
							<p style="color: #3239FF;">绑定手机</p>
						</li>
					</ul>
					<div class="form">
						<input type="number" name="" value="" placeholder="请输入新手机号" v-model="loginPhone"
							oninput="if(value.length>11)value=value.slice(0,11)" maxlength="11" />
						<input type="number" placeholder="请输入验证码" class="postCode" maxlength="6" v-model="loginCode"
							oninput="if(value.length>6)value=value.slice(0,6)" />
						<!-- 验证码倒计时 -->
						<p class="showHand code" @click="throttle(handleRequresCode,3000)">{{codeTime?codeTime:'获取验证码'}}
						</p>
						<button type="button" class="showHand" @click="throttle(conSub,3000)">确定</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		updatePhone
	} from "@/api/setupInfo.js"
	import {
		obtainCode
	} from '@/api/login.js'
	import { fileUpload,appCUserFindById } from '@/api/comm.js'
	let _self;
	let codeTimeEvent;
	export default {
		name: "",
		data() {
			return {
				userInfo: null,
				// 修改手机号状态
				editStatus: false,
				//点击下一步的状态
				nextStatus: false,
				// 倒计时时间
				codeTime: 0,
				// 手机号
				loginPhone: null,
				// 验证码
				loginCode: null,
				//获得的验证码
				sendCode: null,
				//是否允许请求
				isrequest: true,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo = this.getUInfo();
			if(_self.userInfo){
				// console.log("用户信息", _self.userInfo);
				// 有用户信息
				_self.handleUpdateUserInfo();
			}
		},
		// 方法集
		methods: {
			// 更新用户信息
			handleUpdateUserInfo(){
				appCUserFindById({
					userId:_self.userInfo.userId
				}).then(tes=>{
					if(tes.code==200){
						// 接口获取成功
						//定义本地存储的userInfo
						localStorage.setItem('userInfo',JSON.stringify(tes.data))
						// 传递给topBar==用户信息
						_self.$EventBus.$emit('userEditInfo',tes.data)
						// 定义当前用户信息
						_self.$set(_self,'userInfo',tes.data)
					}
				})
			},
			// 请求验证码
			handleRequresCode() {
				// 运行阻止
				if (_self.codeTime) return;

				// 手机号输入判断
				if (_self.loginPhone && _self.loginPhone.length != 11 || !_self.loginPhone) {
					_self.$eror('请输入正确的手机号')
					return false;
				}
				obtainCode({
					phone: _self.loginPhone
				}).then(res => {
					_self.sendCode = res.data
					// 验证接口
					if (res.code == 200) {
						// 时间定义
						_self.codeTime = 60;
						// 清除定时事件
						codeTimeEvent && clearInterval(codeTimeEvent);
						codeTimeEvent = setInterval(res => {
							// 减一
							_self.codeTime--;
							// 归零处理
							if (!_self.codeTime) {
								clearInterval(codeTimeEvent);
							}
						}, 1000)
					}
				})
			},
			// 修改手机号
			aleditPhone() {
				_self.loginPhone = null;
				_self.editStatus = !_self.editStatus;
				if (_self.editStatus) {
					_self.message = '隐藏'
				} else {
					_self.message = '显示'
				}
			},
			// 点击下一步
			next() {
				if (!_self.loginPhone || _self.loginPhone && _self.loginPhone.length != 11) {
					_self.$eror('请输入正确的手机号')
					return false;
				} else if (!_self.loginCode || _self.loginCode && _self.loginCode.length != 6) {
					_self.$eror('请输入正确的验证码')
					return false;
				} else if (_self.loginCode != _self.sendCode) {
					_self.$eror('验证码不正确')
					return false;
				} else if (_self.loginPhone != _self.userInfo.userPhone) {
					_self.$eror('手机号不正确')
					return false;
				} else {
					if (!_self.isrequest) return;
					_self.isrequest = false;


					updatePhone({
						phone: _self.userInfo.userPhone,
						code: _self.sendCode,
						second: false
					}).then(res => {
						if(res.code==200){
							// 提示修改成功
							_self.$message({
								message:res.data,
								type:'success'
							})
							
							//清空表单
							_self.loginPhone=null;
							_self.loginCode=null;
							//清除定时器
							_self.codeTime='';
							clearInterval(codeTimeEvent);
							
							_self.nextStatus = !_self.nextStatus;
							if (_self.nextStatus) {
								_self.message = '隐藏'
								_self.editStatus = false
							} else {
								_self.message = '显示'
							}
						}
						// 允许再次请求
						_self.isrequest=true;
					})
				}
			},
			// 点击确认
			conSub() {
				if (!_self.loginCode || _self.loginCode && _self.loginCode.length != 6) {
					_self.$eror('请输入正确的验证码')
					return false;
				}else if (!_self.loginPhone || _self.loginPhone && _self.loginPhone.length != 11) {
					_self.$eror('请输入正确的手机号')
					return false;
				}else if (_self.loginCode != _self.sendCode) {
					_self.$eror('验证码不正确')
					return false;
				} else {
					if (!_self.isrequest) return;
					_self.isrequest = false;
					
					updatePhone({
						phone: _self.loginPhone,
						code: _self.sendCode,
						second: true,
						UserId:_self.userInfo.userId
					}).then(res=>{
						if(res.code==200){
							// 提示成功
							_self.$message({
								message:res.data,
								type:'success'
							});
							
							// 定义用户的手机号
							_self.userInfo.userPhone=_self.loginPhone;
							// 本地存储用户信息
							localStorage.setItem('userInfo',JSON.stringify(_self.userInfo))
							// 传递给topBar==用户信息
							_self.$EventBus.$emit('userEditInfo',_self.userInfo)
							_self.cancle()
						}
						_self.isrequest=true;
					})
				}
			},
			// 关闭弹框
			cancle() {
				_self.editStatus = false
				_self.nextStatus = false
			}
		},
		// 组件集
		components: {

		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {
			clearInterval(codeTimeEvent)
		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			next();
		},
	}
</script>

<style scoped>
	.main {
		width: 100%;
		background: rgba(255, 255, 255, 0.72);
		padding: 120px 290px;
		box-sizing: border-box;
		margin-bottom: 45px;
	}

	.main figure {
		width: 425px;
		height: 200px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		margin-bottom: 208px;
	}

	.main figure img {
		width: 100px;
		height: 100px;
		margin-bottom: 50px;
	}

	.main figure figcaption {
		width: 425px;
		height: 45px;
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
	}

	.main figure figcaption input {
		width: 300px;
		height: 44px;
		background: #ffffff;
		border: 1px solid #cccccc;
		font-size: 16px;
		font-weight: 400;
		color: #333333;
		letter-spacing: 2px;
		padding: 12px 16px;
		box-sizing: border-box;
	}

	.main figure figcaption p {
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		letter-spacing: 2px;
	}

	.main figure figcaption span {
		font-size: 16px;
		font-weight: 400;
		color: #3239ff;
		letter-spacing: 2px;
	}

	/* 弹框修改手机号 */
	.editPhone {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 210;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
	}

	.editPhone_nav {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 680px;
		height: 450px;
		background: #ffffff;
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.editPhone_nav_top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: 24px;
		font-weight: 400;
		color: #000000;
		letter-spacing: 3px;
	}

	.editPhone_nav_top img {
		width: 20px;
		height: 20px;
		display: block;
	}

	.text {
		width: 250px;
		height: 55px;
		margin: 40px auto;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.text li {
		height: 55px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		font-weight: 400;
		color: #3239ff;
	}

	.text li:nth-last-child(1) {
		height: 55px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		font-weight: 400;
		color: #000000;
	}

	.text li img {
		width: 24px;
		height: 24px;
	}

	.line {
		width: 130px;
		height: 2px;
		background: #dcdfe6;
		margin-top: 10px;
	}

	.form {
		width: 360px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
	}

	.form input {
		width: 360px;
		height: 44px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		padding: 11px 15px;
		box-sizing: border-box;
		font-size: 16px;
		color: #999999;
		letter-spacing: 2px;
		margin-bottom: 30px;
	}

	.code {
		position: fixed;
		right: 177px;
		top: 271px;
		font-size: 16px;
		font-weight: 400;
		color: #e62129;
		letter-spacing: 2px;
	}

	button {
		width: 360px;
		height: 44px;
		background: #e62129;
		font-size: 14px;
		font-weight: 400;
		text-align: center;
		color: #ffffff;
		letter-spacing: 1px;
	}
</style>
